import { render, staticRenderFns } from "./train_index.vue?vue&type=template&id=122e8210&scoped=true&"
import script from "./train_index.vue?vue&type=script&lang=js&"
export * from "./train_index.vue?vue&type=script&lang=js&"
import style0 from "./train_index.vue?vue&type=style&index=0&id=122e8210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e8210",
  null
  
)

export default component.exports